import { TypographyWithIconProps } from 'core/typography-with-icon/typography-with-icon.props';

export const TypographyWithIconPresets: TypographyWithIconProps = {
  gap: '1rem',
  icon: null,
  iconPosition: 'left',
};
